import { Classification } from "./OsmPoiClassifications";
import { useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useOsmPoiContext } from "./OsmPoiContext";
import { faSquareCheck, faSquare } from "@fortawesome/free-regular-svg-icons";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import {
  faCaretRight,
  faSquare as faSquareSolid,
} from "@fortawesome/free-solid-svg-icons";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export interface OsmPoiClassificationListProps {
  classifications: Classification[];
  title: string;
  level?: number;
}

const OsmPoiClassificationList = ({
  classifications,
  title,
  level = 0,
}: OsmPoiClassificationListProps) => {
  const {
    expanded,
    toggleClass,
    expandClass,
    isSelfOrAncestorsSelected,
    anyDecendentSelected,
    sort,
  } = useOsmPoiContext();
  const expandedClassification: Classification | undefined = useMemo(() => {
    if (expanded.classes.length > level) {
      return classifications.find(
        (classification) => classification.Code === expanded.classes[level],
      );
    }
    return undefined;
  }, [expanded]);

  const renderClass = (classification: Classification) => {
    const checkIcon = isSelfOrAncestorsSelected(classification) ? (
      <FontAwesomeIcon
        icon={faSquareCheck as IconProp}
        onClick={() => toggleClass(classification)}
      />
    ) : anyDecendentSelected(classification) ? (
      <FontAwesomeIcon
        icon={faSquareSolid as IconProp}
        onClick={() => toggleClass(classification)}
      />
    ) : (
      <FontAwesomeIcon
        icon={faSquare as IconProp}
        onClick={() => toggleClass(classification)}
      />
    );
    const subClassIndicator = classification.Subclasses ? (
      <FontAwesomeIcon
        icon={faCaretRight}
        onClick={() => expandClass(classification)}
      />
    ) : (
      <div style={{ width: 8 }}></div>
    );
    const simpleClass = (
      <div className="d-flex align-items-center px-2">
        {classification.Subclasses && (
          <div
            className="flex-grow-1"
            onClick={() => expandClass(classification)}>
            <b>{classification.Name}</b>
          </div>
        )}
        {!classification.Subclasses && (
          <div className="flex-grow-1">{classification.Name}</div>
        )}
        {checkIcon}
        {subClassIndicator}
      </div>
    );

    return classification.Description ? (
      <OverlayTrigger
        placement="right"
        delay={{ show: 250, hide: 400 }}
        overlay={<Tooltip>{classification.Description}</Tooltip>}>
        {simpleClass}
      </OverlayTrigger>
    ) : (
      simpleClass
    );
  };

  return (
    <>
      <div className="d-flex flex-column mx-2 flex-shrink-0">
        <h5>{title}</h5>
        <div
          className="card overflow-auto"
          style={{ width: 220, maxHeight: 300 }}>
          {classifications.sort(sort).map((classification, index) => (
            <div
              key={classification.Code}
              style={{ cursor: "default" }}
              className={
                classification.Code === expandedClassification?.Code
                   ? "bg-primary text-white"
                  : (index % 2 === 0 ? "bg-medium" : "")
              }>
              {renderClass(classification)}
            </div>
          ))}
        </div>
      </div>

      {expandedClassification && expandedClassification.Subclasses && (
        <OsmPoiClassificationList
          classifications={expandedClassification.Subclasses}
          title={expandedClassification.Name}
          level={level + 1}
        />
      )}
    </>
  );
};

export default OsmPoiClassificationList;
